import React from 'react';
import { FILTER_CONTROL } from 'config/types/prop';
import withStyles from 'isomorphic-style-loader/withStyles';
import RadioGroup from 'components/form/radioGroup';

import styles from './filterMenu.css';

const ButtonControl = ({
  label,
  name,
  options,
  onChange,
  selected,
}) => (
  <div className={styles.buttonWrapper}>
    <label
      className={styles.label}
      htmlFor={name}
    >
      {label}
    </label>
    <RadioGroup
      name={name}
      inputs={options}
      currentValue={selected}
      className={styles.filterButtons}
      createOnChange={() => (e) => onChange(e)}
    />
  </div>
);

ButtonControl.propTypes = FILTER_CONTROL;
ButtonControl.defaultProps = {
  defaultLabel: '',
  selected: '',
};

export default withStyles(styles)(ButtonControl);
